document.addEventListener('DOMContentLoaded', function () {
  var bottone = document.getElementById('toggle-testo');
  var contenuto = document.getElementById('testo-nascosto');

  if (!bottone || !contenuto) return;

  bottone.addEventListener('click', function () {
    var aperto = !contenuto.hasAttribute('hidden');

    if (aperto) {
      contenuto.setAttribute('hidden', '');
      bottone.setAttribute('aria-expanded', 'false');
      bottone.textContent = 'Continua a leggere';
    } else {
      contenuto.removeAttribute('hidden');
      bottone.setAttribute('aria-expanded', 'true');
      bottone.textContent = 'Mostra meno';
    }
  });
});